module.exports = __webpack_public_path__ + "assets/img/snowflake-lt.0868c6f6.png";